const url = 'https://script.google.com/macros/s/AKfycbztUK7cB0n4LxJxb6_-KkqlOaA1reIH6UrmIPwBEd-98E043Gxsaw5CDo0_zhQEAtB-JQ/exec';


export async function getAmount(address) {
    if (address == '' || address == '0x0') {
        console.log('none-address')
        return 0;
    } else {
        const response = await fetch(url + "?type=" + "address" + "&address=" + address);

        let amount = await response.json();

        console.log(amount);

        amount = amount.map(x => x.toFixed(2));

        console.log(amount);

        return amount;
    }
} 


export async function getHeaders() {
    const response = await fetch(url + "?type=" + "headers" + "&address=" + ' ');

    let headers = await response.json();

    console.log(headers);
    // 2d array, first row APR, second row headers
    headers[0] = headers[0].map(x => (x*100).toFixed(2))

    let rows;
    for (rows = 0; rows < headers[0].length; rows++) {
        if (headers[0][rows] == "0.00") break;
    }

    const dates = headers[1].map(x => new Date(x));
    headers[1] = dates.map(x => x.toLocaleDateString());

    let newHeaders = [...Array(2)].map(e => Array(rows).fill(0));
    for (let i = 0; i < rows; i++) {
        newHeaders[0][i] = headers[0][i];
        newHeaders[1][i] = headers[1][i];
    }
    return newHeaders;
}